import { useState, useEffect } from 'react';
import { getNumberOfRequests } from "../../../APIs/auditor_dashboard";

const useNumberOfRequests = (filters, setLoading) => {
    const [data, setData] = useState(0);

    const fetchNumberOfRequests = async () => {
        try {
            setLoading(true);
            const response = await getNumberOfRequests(filters);
            setData(response.data.count);
        } catch (error) {
            console.error('Error fetching number of requests:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNumberOfRequests();
    }, [filters]);

    return data;
};

export default useNumberOfRequests;
